import React, { FC, useState } from "react";
import cn from "classnames";

import MainAsideMenuLayout from "../../components/layouts/mainAsideMenuLayout/MainAsideMenuLayout";
import CropsDashboard from "./crops";
import ExpensesDashboard from "./expenses";
import WorksDashboard from "./works";
import HeaderDashboardLayout from "../../components/layouts/headerDashboardLayout/HeaderDashboardLayout";
import StateCropsDashboard from "./statecrops";
import Tx from "../../types/naming";

import st from "./dashboardPage.module.scss";
import NDVIdashboard from "./ndvi";
import { useTypedSelector } from "@hooks/useTypedSelector";
import PhasesWithArea from "@pages/dashboard/phases/phasesWithArea";
import PhasesWithPeriod from "@pages/dashboard/phases/phasesWithPeriod";
import VehiclesStatuses from './vehiclesStatuses';
import useFetchVehicles from "@pages/dashboard/hooks/useFetchVehicles";
import VehiclesTypes from "@pages/dashboard/vehiclesTypes";
import * as Highcharts from 'highcharts';

interface DashboardPageProps {
    children: any;
}

export const withLayout = (Component: FC<any>) => {
    return (props: any) => {
        const { dashboard: { mainMenuVisible, refreshKey } } = useTypedSelector(x => x.applicationSettings)
        const Layout = mainMenuVisible === false ? React.Fragment : MainAsideMenuLayout
        return <Layout>
            <Component {...props} key={refreshKey}></Component>
        </Layout>
    }
}

const DashboardPageContainer: FC<DashboardPageProps> = ({}) => {
    const [phasesChartApi, setPhasesChartApi] = useState<Highcharts.Chart>()

    useFetchVehicles()

    return (
        <HeaderDashboardLayout title={Tx.Analytics}>
            <div className={st["grid"]}>
                <div className={cn(st["grid-block"], st["units_state"])}>
                    <VehiclesStatuses />
                </div>
                <div className={cn(st["grid-block"], st["units_types"])}>
                    <VehiclesTypes />
                </div>
                <div className={cn(st["grid-block--two-rows"], st["grid-block"], st["works_progress"])}>
                    <WorksDashboard />
                </div>
                <div className={cn(st["grid-block"], st["crops"])}>
                    <CropsDashboard />
                </div>
                <div className={cn(st["grid-block"], st["crops_state"])}>
                    <StateCropsDashboard />
                </div>
                <div className={cn(st["grid-block--two-rows"], st["grid-block"], st["expenses"])}>
                    <ExpensesDashboard />
                </div>
                <div className={cn(st["grid-block"], st["indexes"])}>
                    <NDVIdashboard />
                </div>
                <div className={cn(st["grid-block"], st["grow_phases-one"])}>
                    <PhasesWithArea phasesChartApi={phasesChartApi} />
                </div>
                <div className={cn(st["grid-block--two-rows"], st["grid-block"], st["grow_phases-two"])}>
                    <PhasesWithPeriod setPhasesChartApi={setPhasesChartApi} />
                </div>
            </div>
        </HeaderDashboardLayout>
    );
};

export default withLayout(DashboardPageContainer);